import Footer from "../../helperComponents/Footer/Footer";
import Header from "../../helperComponents/Header/header";
import PreFooter from "../../helperComponents/PreFooter/Prefooter";
import { useMediaQuery } from "react-responsive";
import { GoArrowUpRight } from "react-icons/go";
import './explore.scss';
import SplitType from "split-type";
import gsap from "gsap";
import { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";

export default function Explore() {
    const isMediumScreen = useMediaQuery({ query: '(max-width: 850px)' });
    const isAlmostMediumScreen = useMediaQuery({ query: '(max-width: 1212px)' });
    
    const [exploreData, setExploreData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProps = async () => {
            const { data, error } = await supabase
                .from('explore_props')
                .select('*')
                .order('created_at', { ascending: false });
            
            if (!error && data) {
                setExploreData(data);
            }
            setLoading(false);
        };
        fetchProps();
    }, []);

    useEffect(() => {
        if (loading) return;
        new SplitType('.explore__containerText1');
        const tl1 = gsap.timeline();

        tl1.to(".explore__containerText1", {
            duration: .5,
            y: 0,
            height: "fit-content",// Or an appropriate maximum height
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", // Animate to full view
            ease: "power4.inOut",
            opacity: 1,
            paddingBottom: '20px',
            stagger: {
                amount: 0.3
            }
        }).to(".char", {
            duration: .7,
            y: 0,
            ease: "power4.inOut",
            stagger: {
                amount: 0.3
            }
        }).to(".explore__containerText2", {
            duration: 1,
            x: 0,
            ease: "power2.inOut",
            opacity: 1,
            width: isMediumScreen? '100%' : '40%',
            skewX: '0deg',
            stagger: {
                amount: 0.3
            }
        }, '-=.7').to(".explore__containerBreaker", {
            duration: .5,
            opacity: 1,
            ease: "power4.inOut",
            stagger: {
                amount: 0.3
            }
        })

        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <main className="explore__container">
            <Header isHomepage={false} />
            <section className="gallery__container__main" style={{ padding: isMediumScreen ? '0 16px' : '0 70px', marginTop: isMediumScreen ? '80px' : '150px' }}>
                <section className="gallery__container__main1" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ fontWeight: 500, lineHeight: '110px', gap: '8px', }}>
                        <p className="explore__containerText1" style={{ fontStyle: 'italic', fontSize: isMediumScreen ? "42px" : '120px', }}>
                            Explore
                        </p>
                    </div>
                    <p className="explore__containerText2" style={{ marginBottom: isMediumScreen ? "75px" : '140px', marginTop: isMediumScreen ? "28px" : '70px', lineHeight: '30px', fontSize: '20px', fontWeight: 400, width: isMediumScreen ? '100%' : '40%', textAlign: 'center' }}>Rent equipments you need in order to bring your events to life & create memorable experiences..</p>
                    <hr className="explore__containerBreaker" style={{ background: "#E3D4CE", width: '100%', height: '1px', opacity: .5 }}></hr>
                </section>
                <section className="gallery__container__main2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', columnGap: '20px', rowGap:isMediumScreen? '90px' : '150px', width: '100%', marginTop: isMediumScreen? '40px' : '104px', marginBottom: '240px' }}>
                    {
                        exploreData.map((explore, index) => (
                            <div style={{ width: isAlmostMediumScreen? "100%" : '32%' }} key={explore.id || index}>
                                <div
                                    style={{
                                        width: '100%',
                                        height: isAlmostMediumScreen ? '400px' : '560px',
                                        backgroundImage: `url(${explore.cloudinary_url ? explore.cloudinary_url.replace('/upload/', '/upload/q_auto,f_auto,w_800/') : ''})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        display: 'flex',
                                        backgroundColor: '#eee'
                                    }}
                                ></div>
                                <p className="explore__title" style={{ marginBottom: isMediumScreen? "10px" : '14px', marginTop: isMediumScreen? "23px" : '32px', fontWeight: 500, fontSize: isMediumScreen? '20px' : '30px', lineHeight: isMediumScreen? '25px' : '38px' }}>{explore.title}</p>
                                <p style={{ marginBottom: isMediumScreen? "32px" : '42px', fontSize: isMediumScreen? '14px' : '20px', lineHeight: isMediumScreen? '17px' : '24px', color: '#969292' }}>{explore.price}</p>
                                <a href="/contact" style={{cursor: 'pointer', width: '100%', borderRadius: '100px', padding: '18px 24px', background: '#916859', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', gap: '7px' }}>
                                    <p style={{fontSize: isMediumScreen? '15px' : '20px'}}>Rent Now</p>
                                    <GoArrowUpRight fontSize={isMediumScreen? 12 : 20} />
                                </a>
                            </div>
                        ))
                    }
                </section>
            </section>
            <PreFooter />
            <Footer />
        </main >
    )
}